/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';

import styled from 'styled-components';
import { connect } from 'react-redux';
import { providerDeviceStatusSaga } from '../action-creators';
import { Accordion, Header, Icon, List, Segment } from 'semantic-ui-react';
import { DeviceIcon } from '../components/device-icon';
import { Timestamp } from '../components/timestamp';
import { colors } from '../themes';

const Title = styled.span`
  color: ${({ color }) => color};
`;

const DateSection = styled.span`
  padding-left: 9px;
`;

const TS = styled.span`
  padding-left: 9px;
`;

const Reported = styled.section`
  margin-bottom: 6px;
`;

const ReportedTS = styled.div`
  color: black;
`;

/**
 * The last blob the device reported. The status-history collection is gone, so
 * this is the single current record rather than a list.
 */
export function ReportedStatus(props: { status: any }) {
  const { status } = props;
  const [open, setOpen] = useState(false);

  return (
    <Accordion fluid>
      <Accordion.Title active={open} index={0} onClick={() => setOpen(!open)}>
        <Icon name="dropdown" />
        Reported status
      </Accordion.Title>
      <Accordion.Content active={open}>
        <Reported>
          {status.lastUpdatedOn && (
            <ReportedTS>
              <Timestamp value={status.lastUpdatedOn} />
            </ReportedTS>
          )}
          <code>{JSON.stringify(status)}</code>
        </Reported>
      </Accordion.Content>
    </Accordion>
  );
}

export function DeviceStatus(props: any) {
  const { uuid, kind, online, status } = props.device;
  const color = online ? colors.baseColors.green : colors.baseColors.red;
  return (
    <List.Item>
      <List.Content>
        <List.Header as="span">
          <DeviceIcon online={online} deviceType={kind} />
          <Title color={color}>
            {uuid}
            {!online && <DateSection>Offline</DateSection>}
            {status?.lastUpdatedOn && (
              <DateSection>
                Last reported:
                <TS>
                  <Timestamp value={status.lastUpdatedOn} />
                </TS>
              </DateSection>
            )}
          </Title>
        </List.Header>
        {status && (
          <List.Description as="span">
            <ReportedStatus status={status} />
          </List.Description>
        )}
      </List.Content>
    </List.Item>
  );
}

export function ProviderDevices(props: any) {
  return (
    <Segment>
      <Header>{props.serviceProvider.name}</Header>
      <List divided relaxed>
        {props.devices.map((d: any) => (
          <DeviceStatus key={d.uuid} device={d} />
        ))}
      </List>
    </Segment>
  );
}

export function $DeviceStatusPage(props: any) {
  return (
    <Segment.Group>
      {props.devicesByProvider.map((pd: any) => (
        <ProviderDevices key={pd.serviceProviderId} devices={pd.devices} serviceProvider={pd.serviceProvider} />
      ))}
    </Segment.Group>
  );
}

function mapStateToProps(state: any) {
  return state.iotDeviceStatus;
}

function mapDispatchToProps(dispatch: any) {
  return {
    onProviderChange: (serviceProviderId: any) => dispatch(providerDeviceStatusSaga(serviceProviderId))
  };
}

export const DeviceStatusPage = connect(mapStateToProps, mapDispatchToProps)($DeviceStatusPage);
